<template>
    <div>
        <div class="middle" style="margin-top:146px;">
            <div class="banner">
                <el-carousel class="banner-imgs" :interval="8000" indicator-position="none">
                    <el-carousel-item v-for="(bannerImg, index) in bannerList" :key="index">
                        <img :src="bannerImg.url?bannerImg.url:require('../../assets/imgs/banner_news.png')"
                             style="width:100%;height:100%;" />
                    </el-carousel-item>
                </el-carousel>
            </div>
            <div class="user-content">
                <div class="list">
                    <div class="menu" style="font-size: 14px;color: #3d3d3d;text-align: left;">
                        <ul class="user-menu" v-for="(item, index) in navList" :key="index">
                            <li v-if="item.visible == true"
                                :key="index"
                                @click="goPath(item.path, item.id)"
                                :class="currentNav===item.id?'active':''">
                                <img :src="currentNav===item.id?item.iconSelected:item.icon" alt />
                                {{item.name}}
                            </li>
                        </ul>
                    </div>
                </div>
                <keep-alive>
                    <router-view />
                </keep-alive>
            </div>
        </div>

        <el-dialog id="account-pwd"
                   title=""
                   :visible.sync="warnningShow"
                   width="20%"
                   :center="false"
                   top="20vh"
                   :close-on-click-modal="false"
                   :lock-scroll="false">
            <el-form>
                <el-row>
                    <div>
                        <img :src="require('../../assets/imgs/code_ico1.jpg')" style="width:100%;height:100%;" />
                    </div>
                </el-row>
                <el-row>
                    <span style="font-weight: bold;font-size: 16px; color: red;">请扫码关注公众号并完成相应的业务操作!</span>
                </el-row>
                <el-row>
                    <el-col>
                        <el-button type="primary" style="width: 100%;margin-top:15px;" @click="closeWarn()">关 闭</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </el-dialog>

        <el-dialog id="account-pwd"
                   title=""
                   :visible.sync="warnningShow2"
                   width="20%"
                   :center="false"
                   top="20vh"
                   :close-on-click-modal="false"
                   :lock-scroll="false">
            <el-form>
                <el-row>
                    <div>
                        <img :src="require('../../assets/imgs/code_ico1.jpg')" style="width:100%;height:100%;" />
                    </div>
                </el-row>
                <el-row>
                    <span style="font-weight: bold;font-size: 16px; color: red;">尊敬的租户，开票请扫码登录公众号进行操作!</span>
                </el-row>
                <el-row>
                    <el-col>
                        <el-button type="primary" style="width: 100%;margin-top:15px;" @click="closeWarn2()">关 闭</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import "@/assets/css/userindex.less";
    import UserApi from "@/api/user/index";

    export default {
        name: "UserIndex",
        data() {
            return {
                warnningShow: false,
                warnningShow2:false,
                currentNav: 0,
                bannerList: [
                    {
                        url: require("../../assets/imgs/banner_news.png"),
                        urlAddr: "#",
                    },
                ],
                navList: [
                    {
                        id: 0,
                        name: "我的申请",
                        path: "/User",
                        icon: require("../../assets/imgs/left_ico9.png"),
                        iconSelected: require("../../assets/imgs/left_ico9_hover.png"),
                        visible: true
                    },
                    {
                        id: 1,
                        name: "我的预约",
                        path: "/User/MyAppointment",
                        icon: require("../../assets/imgs/left_ico9.png"),
                        iconSelected: require("../../assets/imgs/left_ico9_hover.png"),
                        visible: true
                    },
                    {
                        id: 2,
                        name: "排号查询",
                        path: "/User/QuerySequence",
                        icon: require("../../assets/imgs/left_ico6.png"),
                        iconSelected: require("../../assets/imgs/left_ico6_hover.png"),
                        visible: false
                    },
                    {
                        id: 3,
                        name: "在线选房",
                        path: "/User/SelectRoom",
                        icon: require("../../assets/imgs/left_ico2.png"),
                        iconSelected: require("../../assets/imgs/left_ico2_hover.png"),
                        visible: true
                    },
                    {
                        id: 4,
                        name: "我的合同",
                        path: "/User/MyContract",
                        icon: require("../../assets/imgs/left_ico8.png"),
                        iconSelected: require("../../assets/imgs/left_ico8_hover.png"),
                        visible: true
                    },
                    // {
                    //     id: 5,
                    //     name: '基本信息',
                    //     path: '/User/ModifyUserInfo',
                    //     icon: require('../../assets/imgs/left_ico1.png'),
                    //     iconSelected: require('../../assets/imgs/left_ico8_hover.png'),
                    //     visible: true
                    // },
                    {
                        id: 6,
                        name: "在线缴费",
                        path: "/User/MyPaymentList",
                        icon: require("../../assets/imgs/left_ico7.png"),
                        iconSelected: require("../../assets/imgs/left_ico7_hover.png"),
                        visible: true
                    },
                    // {
                    //   id: 5,
                    //   name: "审核进度",
                    //   path: "/User/OrderManage",
                    //   icon: require("../../assets/imgs/left_ico6.png"),
                    //   iconSelected: require("../../assets/imgs/left_ico6_hover.png"),
                    // },
                    {
                        id: 7,
                        name: "续租申请",
                        path: "/User/RerentConsultion",
                        icon: require("../../assets/imgs/left_ico5.png"),
                        iconSelected: require("../../assets/imgs/left_ico5_hover.png"),
                        visible: true
                    },
                    {
                        id: 8,
                        name: "提前退租",
                        path: "/User/RentCancellation",
                        icon: require("../../assets/imgs/left_ico4.png"),
                        iconSelected: require("../../assets/imgs/left_ico4_hover.png"),
                        visible: true
                    },
                    {
                        id: 9,
                        name: "在线报修",
                        path: "/User/MyRepairList",
                        icon: require("../../assets/imgs/left_ico3.png"),
                        iconSelected: require("../../assets/imgs/left_ico3_hover.png"),
                        visible: true
                    },
                    {
                        id: 10,
                        name: "电子发票",
                        path: "/User/MyInvoice",
                        icon: require("../../assets/imgs/left_ico2.png"),
                        iconSelected: require("../../assets/imgs/left_ico2_hover.png"),
                        visible: true
                    },
                    {
                        id: 11,
                        name: "账号管理",
                        path: "/User/Account",
                        icon: require("../../assets/imgs/left_ico2.png"),
                        iconSelected: require("../../assets/imgs/left_ico2_hover.png"),
                        visible: true
                    },

                ]
            };
        },
        methods: {
            closeWarn() {
                this.warnningShow = false
            },
            closeWarn2(){
                this.warnningShow2 = false
            },
            goPath(path, id) {
                this.currentNav = id;
                //11账号管理 10电子发票 9在线报修 8提前退租 6在线缴费(可查看不可在线缴费) 5基本信息 4我的合同 3在线选房 2排号查询 1我的预约 0我的申请
                if (id == 9 || id == 8 || id == 3) {
                    this.warnningShow = true
                }
                else if(id ==10){
                    this.warnningShow2 = true
                    this.$router.push({ path: path });
                }
                else {
                    this.$router.push({ path: path });
                }
            },
            resetNav() {
                var routePath = this.$route.path;
                var currentNav = this.currentNav;

                this.navList.forEach(function (ele) {
                    if (ele.path == routePath) {
                        currentNav = ele.id;
                    }
                });

                this.currentNav = currentNav;
            }
        },
        activated() {
            this.resetNav();
            var that = this;
            this.navList[2].visible = false;
            this.navList[3].visible = false;
            UserApi.getRentInfo().then(res => {
                if (res.success) {
                    if (res.data.status == "10") {
                        that.navList[2].visible = true;
                    }

                    if (res.data.status == "10" || (res.data.status == "11" && res.data.allocateType == 2)) {
                        that.navList[3].visible = true;
                    }

                    if (res.data.needSignContractNo != null && res.data.needSignContractNo != "") {
                        this.$alert("<span style='color:red'>您有一份合同已缴费但是未在线签约，请立即请往签约！</span>", "提示"
                            , {
                                confirmButtonText: "现在就去",
                                dangerouslyUseHTMLString: true,
                                showClose: false,
                                type: 'info'
                            })
                            .then(() => {
                                this.$router.push("/User/MyContract");
                            })
                    }
                }
            })
        },
        watch: {
            $route() {
                //跳转到该页面后需要进行的操作
                this.resetNav();
            }
        },
    };
</script>

<style scoped>
</style>